import { createReducer, on } from '@ngrx/store';

import * as RolesActions from '../actions/roles.actions';
import { RoleData } from '../../interfaces/roles.model';

export interface RoleState {
  entities: Array<RoleData>;
  allRoles: Array<RoleData>;
  loaded: boolean;
  loading: boolean;
  allLoaded: boolean;
  allLoading: boolean;
  total: number;
  importing: boolean;
  imported: boolean;
}

export const initialState: RoleState = {
  entities: [],
  allRoles: [],
  loaded: false,
  loading: false,
  allLoaded: false,
  allLoading: false,
  total: 0,
  importing: false,
  imported: false
};

const rolesReducer = createReducer(
  initialState,
  on(RolesActions.loadRoles, state => ({ ...state, loading: true })),
  on(RolesActions.loadRolesSuccess, (state, { payload }) => {
    const roles = payload;
    const total = roles.total;
    const entities = roles.results.reduce((all: { [uid: string]: RoleData }, item: RoleData) => {
      return { ...all, [item.uid]: item };
    }, {});
    return { ...state, loading: false, loaded: true, entities, total };
  }),
  on(RolesActions.loadRolesFail, state => ({ ...state, loading: false, loaded: false })),
  on(RolesActions.loadMoreRoles, state => ({ ...state, loading: true })),
  on(RolesActions.loadMoreRolesSuccess, (state, { payload }) => {
    const roles = { ...payload, results:[...payload.results, ...Object.values(state.entities)] };
    const total = roles.total;
    const entities = roles.results.reduce((all: { [uid: string]: RoleData }, item: RoleData) => {
      return { ...all, [item.uid]: item };
    }, {});

    return { ...state, loading: false, loaded: true, entities, total };
  }),
  on(RolesActions.loadMoreRolesFail, state => ({ ...state, loading: false, loaded: false })),
  on(RolesActions.loadAllRoles, state => ({ ...state, AllLoading: true })),
  on(RolesActions.loadAllRolesSuccess, (state, { payload }) => {
    const roles = payload;

    const allRoles = roles.reduce((all: { [uid: string]: RoleData }, item: RoleData) => {
      return { ...all, [item.uid]: item };
    }, {});

    return { ...state, allLoading: false, allLoaded: true, allRoles };
  }),
  on(RolesActions.loadAllRolesFail, state => ({ ...state, allLoading: false, allLoaded: false })),
  on(RolesActions.searchRoles, state => ({ ...state, loading: true })),
  on(RolesActions.searchRolesSuccess, (state, { payload }) => {
    const roles = payload;
    const entities = roles.reduce((all: { [uid: string]: RoleData }, item: RoleData) => {
      return { ...all, [item.uid]: item };
    }, {});

    return { ...state, loading: false, loaded: true, entities };
  }),
  on(RolesActions.searchRolesFail, state => ({ ...state, loading: false, loaded: false }))
);

export function reducer(state, action) {
  return rolesReducer(state, action);
}

export const getRolesEntities = (state: RoleState) => state?.entities;
export const getRolesLoading = (state: RoleState) => state?.loading;
export const getRolesLoaded = (state: RoleState) => state?.loaded;
export const getTotalRoles = (state: RoleState) => state?.total;

export const getAllRolesEntities = (state: RoleState) => state?.allRoles;
export const getAllRolesLoading = (state: RoleState) => state?.allLoading;
export const getAllRolesLoaded = (state: RoleState) => state?.allLoaded;
